// src/hooks/useDynamicResources.js
import { useState, useEffect, useCallback } from 'react';
import customizationsV2Service from '../../services/api/customizations-v2-service'; // Adjust path as needed
import { toast } from 'react-toastify';

const useDynamicResources = (projectId, version, configId, horizontalTab, configSchema) => {
  const [resourceList, setResourceList] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchResources = useCallback(async () => {
    if (!configSchema) return; 
    const shouldFetchForTab = horizontalTab === 'category' || horizontalTab === 'home'|| horizontalTab === 'article';
  
    const canFetch = (projectId && version) || configId;

    if (!canFetch || !shouldFetchForTab) {
        // If not on a relevant tab after initial load, or no identifiers, clear existing resources or do nothing
        // setResourceList({}); // Optional: clear if navigating away from relevant tabs
        return;
    }

    setIsLoading(true);
    setError(null);
    try {
      let payload = {};
      if (configId) {
        payload = { config_id: configId };
      } else {
        payload = { projectId, version };
      }
      
      // We might not need to send the whole 'config' (configSchema) to this endpoint
      // if the backend can derive what it needs from projectId/version or config_id.
      // If 'config' (schema) is truly needed by backend for /get-resources, add it to payload.
      // payload.config = configSchema; 

      const response = await customizationsV2Service.getV2Resources(payload);
      if (response.status) {
        setResourceList(response.data || {});
      } else {
        setError(response.error || 'Failed to fetch resources');
        toast.error(response.error?.msg || 'Failed to fetch resources');
        setResourceList({});
      }
    } catch (err) {
      console.error("Error fetching dynamic resources:", err);
      setError(err.message || 'An error occurred while fetching resources.');
      toast.error(err.message || 'An error occurred while fetching resources.');
      setResourceList({});
    } finally {
      setIsLoading(false);
    }
  }, [projectId, version, configId, horizontalTab, configSchema]);

  useEffect(() => {
    fetchResources();
  }, [fetchResources]); // fetchResources is memoized and includes all its dependencies

  return { resourceList, isLoading, error, refetchResources: fetchResources };
};

export default useDynamicResources;
